import imageOne from '@/assets/images/cities/halifax1.jpg'
import imageTwo from '@/assets/images/cities/halifax2.jpg'
import imageThree from '@/assets/images/cities/halifax3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Halifax',
  writeup: '',
  website: 'MyHalifaxNotaryPublic.com',
  url: 'https://www.myhalifaxnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: ''
      },
      address: '1888 Brunswick Street Location',
      notes: 'Hours vary by week, please contact us to learn more.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/novaScotia/cities/halifax.js